import { FONT_IDENTITY_MATRIX } from "pdfjs-dist/types/src/shared/util";
import { PreLoadHelper } from "../Helpers/helpers";
const Genesis = require("../Genesis.js");

export class ISiteMobileAccountLoginPage {

    constructor() { }

    public Init() {
        $('#sign-in').click(() => this.showPreLoader());
        $('#alert-slow-login').hide();
        var scannedCode = localStorage.getItem('ScannedCode');
        if (scannedCode != null) {
            localStorage.removeItem('ScannedCode');
        }
    }

    private showPreLoader() {
        const helper = new PreLoadHelper();
        helper.showPreLoader(10000, () => { $('#alert-slow-login').show() });
    }
}